import {organizationCodeService} from "./organizationCodeService";
import mixnit_addHook from "./mixnit";


/**
 * Base pour les stores
 * @param ctx
 * @returns {*}
 */
export function withOrganizationCodeLookup(ctx) {

    // Attention a bien utiliser this dans le hook et pas ctx :  this est garanti piur contenir le store
    // complet après sa composition au moment ou Alpine appelle le init) du store
    // Rien ne garantit que ctx référence ce même objet store complet
    // 123 456 789 14526
    // 12345678914526
    mixnit_addHook(ctx, 'afterInit', function () {
        const service = organizationCodeService(this)
        this._organizationService = service
    })

    ctx.resolverOrganizationData = null

    ctx.handleOrganizationCodeChange = function (value, meta) {
        if (!meta?.type) {
            this.serverValidation.organizationCode = {
                status: 'idle',
                data: null,
                lastCheckedValue: value
            }
            return
        }
        this._organizationService.scheduleCheck(value)
    }

    ctx.setResolverOrganizationData = function (data) {
        this.resolverOrganizationData = data
    }

    ctx.getResolverOrganizationData = function () {
        return this.resolverOrganizationData
    }

    return ctx
}
